import React from 'react';
import { YEARS, formatProjection } from '../../../helpers';
import './index.scss';
import { data } from '../../../data';

interface SortingTabsProps {
  specialitySorting: typeof data.sorting.speciality;
  activeSorting: {
    year: number;
    speciality: string;
    category: string;
  };
  sortingChangeHandler: (type: string, value: number | string) => void;
}

const SortingTabs: React.FC<SortingTabsProps> = ({ specialitySorting, activeSorting, sortingChangeHandler }) => (
  <div className="sorting-tabs">
    <div className="year">
      {YEARS.map((year) => (
        <a
          href="#"
          key={`tab-year-${year}`}
          className={year === activeSorting.year ? 'active' : ''}
          onClick={(e) => {
            e.preventDefault();
            sortingChangeHandler('year', year);
          }}
        >
          {formatProjection(year)}
        </a>
      ))}
    </div>
    <div className="speciality">
      {specialitySorting.map(({ title, value, accentColor }) => (
        <a
          href="#"
          key={`tab-speciality-${title}`}
          className={`${accentColor} ${value === activeSorting.speciality ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            sortingChangeHandler('speciality', value);
          }}
        >
          {title}
        </a>
      ))}
    </div>
  </div>
);

export default SortingTabs;
